// extracted by mini-css-extract-plugin
export var articles = "recentArticles-module--articles--13f9f";
export var eyebrow = "recentArticles-module--eyebrow--521a4";
export var headline = "recentArticles-module--headline--a0683";
export var recentArticles = "recentArticles-module--recent-articles--d288d";